import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchRooms, addRoom, updateRoomData, removeRoom } from "../redux/slices/roomSlice";
import "../styles/TableStyles.css";

function RoomManagement() {
  const dispatch = useDispatch();
  const { rooms, loading, error } = useSelector((state) => state.rooms);
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [formData, setFormData] = useState({
    roomNumber: "",
    capacity: 1,
  });
  const [formError, setFormError] = useState("");

  useEffect(() => {
    dispatch(fetchRooms());
  }, [dispatch]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: name === "capacity" ? parseInt(value) : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setFormError("");

    if (!formData.roomNumber || !formData.capacity) {
      setFormError("Please fill in all fields");
      return;
    }

    if (editingId) {
      dispatch(updateRoomData({ id: editingId, roomData: formData }));
    } else {
      dispatch(addRoom(formData));
    }

    setFormData({ roomNumber: "", capacity: 1 });
    setEditingId(null);
    setShowForm(false);
  };

  const handleEdit = (room) => {
    setFormData({ roomNumber: room.room_number, capacity: room.capacity });
    setEditingId(room.room_id);
    setShowForm(true);
  };

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this room?")) {
      dispatch(removeRoom(id));
    }
  };

  const handleCancel = () => {
    setFormData({ roomNumber: "", capacity: 1 });
    setEditingId(null);
    setShowForm(false);
    setFormError("");
  };

  if (loading) return <div className="loading">Loading rooms...</div>;

  return (
    <div className="management-container">
      <h2>Room Management</h2>

      {error && <div className="error">Error: {error}</div>}

      {!showForm ? (
        <>
          <button
            className="add-btn"
            onClick={() => setShowForm(true)}
            style={{ marginBottom: "20px" }}
          >
            + Add New Room
          </button>

          <div className="table-container">
            {rooms.length === 0 ? (
              <p className="no-data">No rooms found</p>
            ) : (
              <table className="modern-table">
                <thead>
                  <tr>
                    <th>Room Number</th>
                    <th>Capacity</th>
                    <th>Created At</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {rooms.map((room) => (
                    <tr key={room.room_id}>
                      <td>{room.room_number}</td>
                      <td>{room.capacity}</td>
                      <td>{new Date(room.created_at).toLocaleDateString()}</td>
                      <td>
                        <button
                          className="edit-btn"
                          onClick={() => handleEdit(room)}
                        >
                          Edit
                        </button>
                        <button
                          className="delete-btn"
                          onClick={() => handleDelete(room.room_id)}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </>
      ) : (
        <div className="form-container">
          <h3>{editingId ? "Edit Room" : "Add New Room"}</h3>

          {formError && (
            <div
              style={{
                color: "#d32f2f",
                marginBottom: "15px",
                padding: "10px",
                backgroundColor: "#ffebee",
                borderRadius: "4px",
              }}
            >
              {formError}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div>
              <label>Room Number</label>
              <input
                type="text"
                name="roomNumber"
                value={formData.roomNumber}
                onChange={handleChange}
                placeholder="e.g., Room A"
                required
              />
            </div>

            <div>
              <label>Capacity</label>
              <input
                type="number"
                name="capacity"
                value={formData.capacity}
                onChange={handleChange}
                min="1"
                required
              />
            </div>

            <div style={{ display: "flex", gap: "10px" }}>
              <button type="submit" className="submit-btn">
                {editingId ? "Update Room" : "Add Room"}
              </button>
              <button
                type="button"
                className="cancel-btn"
                onClick={handleCancel}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
}

export default RoomManagement;
